namespace('compass.group');
compass.require('compass.group.ListLoaderTransferWidget');
compass.require('compass.group.ListLoaderSubmissionResultsWidget');
compass.require('compass.group.ListLoaderProcessingWidget');

compass.group.ListLoaderWidget = compass.defineWidget(function ListLoaderWidget(options) {
     var me = this;
     var $j = jQuery;
     var d = jQuery.dom;
     var _settings = options;
     var listLoaderSubWidgetContainer = d.div({ className: 'ListLoaderSubWidgetContainer'});

     var _drawListLoaderTransferWidget = function() {
          var listLoaderTransferWidget = new compass.group.ListLoaderTransferWidget(listLoaderSubWidgetContainer, {
                    listLoaderSubmissionResultsWidget: _drawListLoaderSubmissionResultsWidget,
                    groupName: _settings.groupName,
                    isCutoff: _settings.isCutoff,
                    listLoaderAllowed: _settings.listLoaderAllowed
               });
          return listLoaderSubWidgetContainer;
     };

     var _drawListLoaderSubmissionResultsWidget = function(roster) {
          _emptyWidget();
          var listLoaderSubmissionResultsWidget = new compass.group.ListLoaderSubmissionResultsWidget(listLoaderSubWidgetContainer, {
               roster: roster,
               listLoaderSubmissionResultsWidget: _drawListLoaderSubmissionResultsWidget,
               listLoaderProcessingWidget: _drawListLoaderProcessingWidget,
               groupName: _settings.groupName,
               commentsAllowed: _settings.commentsAllowed
          });
          return listLoaderSubWidgetContainer;
     };

     var _drawListLoaderProcessingWidget = function(rosterID, numReservations) {
          _emptyWidget();
          var listLoaderProcessingWidget = new compass.group.ListLoaderProcessingWidget(listLoaderSubWidgetContainer, {
               groupName: _settings.groupName,
               rosterID: rosterID,
               numReservations: numReservations
          });
          return listLoaderSubWidgetContainer;
     };

     var _emptyWidget = function() {
          listLoaderSubWidgetContainer.empty();
     };

     var _drawWidget = function() {
          return _drawListLoaderTransferWidget();
     };

     me.bind('ListLoaderWidget.DrawUploadError', function() {
          _emptyWidget();
          var listLoaderTransferWidget = new compass.group.ListLoaderTransferWidget(listLoaderSubWidgetContainer, {
                    listLoaderSubmissionResultsWidget: _drawListLoaderSubmissionResultsWidget,
                    groupName: _settings.groupName,
                    isCutoff: _settings.isCutoff,
                    uploadError: true
               });
          return listLoaderSubWidgetContainer;
     });

     me.render = function(widgetElem) {
          widgetElem.append(_drawWidget());
     };
}, {
     commentsAllowed: true,
     isCutoff: false,
     listLoaderAllowed: true,
     WUID: 'LISTLOADERWIDGET',
     widgetName: 'ListLoaderWidget'
});